import { useQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "app/services/http-services/request-interceptor";

// PRIM-PILOT-043 (ACH-032): mirrors Fluss::MetadataResolver#call_activity_target 1:1 --
// required_inputs (the called process's own Start trigger initial_variables keys) and
// process_outputs (the union of every processOutputs declared on the called process's End
// node(s)). This is a NEW FILE on purpose (not folded into useFlussNodePanelMetadata.ts, which
// stays untouched -- forbidden_scope) so tests can jest.mock it in isolation. Read-only, design
// authoring metadata; has no effect on runtime (see MetadataResolver's own docstring).
export interface CallActivityInterface {
    version: number;
    required_inputs: string[];
    process_outputs: Record<string, { type: string; referenced_table_name?: string }>;
}

interface CallActivityInterfaceEnvelope {
    data: CallActivityInterface | null;
}

export const fetchCallActivityInterface = async (
    definitionKey: string,
    versionPolicy: string,
    pinnedVersion?: string
): Promise<CallActivityInterface | null> => {
    const response = await axiosInterceptor.get<CallActivityInterfaceEnvelope>(
        "/api/fluss/metadata/call_activity_interface",
        {
            params: {
                definition_key: definitionKey,
                version_policy: versionPolicy,
                pinned_version: pinnedVersion || undefined,
            },
        }
    );
    return response.data.data;
};

export const useCallActivityInterface = (
    definitionKey: string,
    versionPolicy: string,
    pinnedVersion?: string
) => useQuery({
    queryKey: ["fluss", "node-panel", "call-activity-interface", definitionKey, versionPolicy, pinnedVersion],
    queryFn: () => fetchCallActivityInterface(definitionKey, versionPolicy, pinnedVersion),
    enabled: Boolean(definitionKey),
});
